declare global {
  interface Window {
    gtag: any
  }
}

export function configGtag({ options }: { options: object }) {
  if (typeof window !== "undefined") {
    window.gtag("config", process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
      ...options,
      debug_mode: process.env.NODE_ENV !== "production" ? true : false,
    })
  }
}

export function setGtag(values: object) {
  if (typeof window !== "undefined") {
    window.gtag("set", {
      ...values,
    })
  }
}
